export function ValueInPropertiesOrErrorsHasChanged(keysObject: {[keys: string]: string}, newProps: {properties: any, errors: {}}, props: {properties: any, errors: {}}) {
    return  newProps.errors !== props.errors || Object.keys(keysObject).some(p => newProps.properties[p] !== props.properties[p]);
}